import { render, staticRenderFns } from "./CreateSerial.vue?vue&type=template&id=e30e9a66&scoped=true"
import script from "./CreateSerial.vue?vue&type=script&lang=js"
export * from "./CreateSerial.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/CU_artist.css?vue&type=style&index=0&id=e30e9a66&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30e9a66",
  null
  
)

export default component.exports